import { render, staticRenderFns } from "./RoltekBanner.vue?vue&type=template&id=977e9776&scoped=true"
import script from "./RoltekBanner.vue?vue&type=script&lang=ts"
export * from "./RoltekBanner.vue?vue&type=script&lang=ts"
import style0 from "./RoltekBanner.vue?vue&type=style&index=0&id=977e9776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977e9776",
  null
  
)

export default component.exports